<template>
	<v-dialog
		v-model="dialog"
		hide-overlay
		transition="dialog-bottom-transition"
		persistent
	>
		<v-card>
			<v-toolbar dark color="secondary">
				<v-card-title>
					<i class="fad fa-layer-group mr-2"></i>
					<span class="headline">{{ formTitle }}</span>
				</v-card-title>
				<v-spacer></v-spacer>
				<button
					type="button"
					class="btn btn-light btn-elevate-hover btn-circle btn-icon btn-sm"
					@click="close"
				>
					<i class="fal fa-times"></i>
				</button>
			</v-toolbar>
			<v-card-text style="min-height: 600px">
				<v-container>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-text-field
								v-model="editedItem.name"
								label="Group Shop Name"
								name="group_shop_name"
								v-validate="'required'"
							></v-text-field>
							<span class="kt-font-danger validate-error">
								{{ errors.first('group_shop_name') }}
							</span>
						</v-col>
					</v-row>
					<v-row>
						<v-col v-show="secretShopper || administrator">
							<label for="dealer">Company</label>
							<vue-select
								id="dealer"
								v-model="editedItem.dealer_id"
								:options="dealers"
								label="name"
								v-validate="'required'"
								:reduce="(dealer) => dealer.id"
								name="company"
								@input="selectedDealer"
								:loading="isCompaniesLoading"
							/>
							<span class="kt-font-danger validate-error">
								{{ errors.first('company') }}
							</span>
						</v-col>
						<v-col
							cols="6"
							v-show="(accountManager && isAutomotive) || secretShopper || administrator"
						>
							<label for="specific_dealer">Dealer</label>
							<vue-select
								:disabled="isDealerEmpty"
								id="specific_dealer"
								v-model="editedItem.specific_dealer_id"
								:options="filteredSpecificDealers"
								name="specific_dealer"
								v-validate="'required'"
								:loading="loading.specificDealer"
								label="name"
								:reduce="(specificDealer) => specificDealer.id"
								taggable
							/>
							<span class="kt-font-danger validate-error">{{
								errors.first('specific_dealer')
							}}</span>
						</v-col>
						<v-col cols="3">
							<v-checkbox
								label="Hide Dealer name"
								v-model="editedItem.hide_dealer_name"
							/>
						</v-col>
						<v-col cols="3">
							<v-checkbox
								label="Hide Detailed Report (Button)"
								v-model="editedItem.hide_detailed_report_btn"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<label for="internet_shop">Internet Shop</label>
							<shop-select-dropdown
								shopType="internetShop"
								:value="editedItem.internet_shops"
								:setShopDropdownValue="setShopDropdownValue"
								:reduce="setShopDropdownValue"
								:key="1"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<label for="internet_shop">Local Competitor</label>
							<vue-select
								:disabled="isCompetitorEmpty"
								id="local_competitor"
								v-model="editedItem.competitor_id"
								:options="localCompetitors"
								name="local_competitor"
								:reduce="(localCompetitor) => localCompetitor.id"
								:getOptionLabel="
									(localCompetitor) =>
										localCompetitor.name + ' - ' + localCompetitor.createdAt
								"
								:loading="loading.localCompetitor"
								label="name"
								taggable
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<label for="phone_shop">Phone Shop</label>
							<shop-select-dropdown
								shopType="phoneShop"
								:value="editedItem.phone_shops"
								:setShopDropdownValue="setShopDropdownValue"
								:key="2"
							/>
						</v-col>
					</v-row>
				</v-container>
				<v-container v-if="editedItem.dealer_id === 48 || item.dealer_id === 48">
					<v-row>
						<v-col>
							<div
								class="v-input--is-label-active v-input--is-dirty theme--light v-text-field v-text-field--is-booted v-select v-autocomplete"
							>
								Shop Request
							</div>
							<vue-select
								@search="searchMysteryShopRequests"
								:filterable="false"
								:reduce="(mysteryShopRequest) => mysteryShopRequest.request_id"
								:options="mysteryShopRequest.items"
								name="mysteryShopRequests"
								append-to-body
								label="request_id"
								v-model="requestId"
								:loading="shopRequestsLoading"
							>
								<template slot="no-options"> No Search Result... </template>
								<template slot="selected-option" slot-scope="option">
									<div class>
										{{ option.request_id }} / {{ option.account_manager }} -
										{{ option.dealer }} /
										{{ option.requested_at }}
									</div>
								</template>
								<template slot="option" slot-scope="option">
									<div class="v-list-item__content">
										<div class="v-list-item__title">
											{{ option.request_id }} / {{ option.account_manager }} -
											{{ option.dealer }} /
											{{ option.requested_at }}
										</div>
									</div>
								</template>
							</vue-select>
						</v-col>
						<v-col>
							<v-autocomplete
								label="Status"
								:items="shopStatuses"
								v-model="shopStatus"
								item-text="friendly_name"
								:loading="shopRequestsLoading"
								item-value="name"
							>
							</v-autocomplete>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-textarea
								clearable
								v-model="shopAdditionalNotes"
								:loading="shopRequestsLoading"
								label="Additional Notes"
							></v-textarea>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="blue-grey darken-1" text @click="close">Cancel</v-btn>
				<v-btn color="blue darken-1" text @click="save" :loading="loading.request"
					>Save</v-btn
				>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import {
	isEmpty as _isEmpty,
	orderBy as _orderBy,
	filter as _filter,
	cloneDeep as _cloneDeep,
	some as _some,
	forEach as _forEach,
	findIndex as _findIndex,
	each as lodashEach,
	isNumber as _isNumber,
	debounce as _debounce,
} from 'lodash-es';
import dayjs from 'dayjs';
import ShopSelectDropdown from '@/components/secretshop/GroupShop/ShopSelectDropdown';

export default {
	name: 'GroupShopForm',
	components: { ShopSelectDropdown },
	props: {
		value: {
			default: false,
			required: true,
			value: Boolean,
		},
		item: {
			default: {},
			required: false,
			value: Object,
		},
		getGroupShops: {
			type: Function,
			required: true,
		},
	},
	watch: {
		value(show) {
			if (show && !_isEmpty(this.item)) {
				this.setEditForm();
			}
		},
	},
	data() {
		return {
			shopRequestsLoading: false,
			specificDealers: [],
			localCompetitors: [],
			isDealerEmpty: true,
			isCompetitorEmpty: true,
			editedItem: {
				name: '',
				dealer_id: '',
				specific_dealer_id: '',
				internet_shops: [],
				phone_shops: [],
				hide_dealer_name: false,
				hide_detailed_report_btn: false,
				competitor_id: '',
			},
			search: {
				phoneShop: '',
				internetShops: '',
			},
			loading: {
				internetShop: false,
				phoneShop: false,
				dealer: false,
				specificDealer: false,
				request: false,
				localCompetitor: false,
			},
			observer: {
				internetShop: null,
				phoneShop: null,
			},
			limit: {
				internetShop: 10,
				phoneShop: 10,
			},
			page: 1,
			mysteryShopRequest: {
				items: [],
				keyword: null,
				pagination: {
					total: 1,
					currentPage: 1,
				},
				selectedItem: {},
			},
			shopStatuses: [],
			requestId: null,
			shopStatus: null,
			shopRequestLoading: true,
		};
	},

	computed: {
		dialog: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('input', value);
			},
		},
		isCompaniesLoading() {
			return this.$store.state.dealers.isFetching;
		},
		dealers() {
			return _orderBy(this.$store.state.dealers.dealers, ['name'], 'asc');
		},
		filteredSpecificDealers() {
			if (this.item.dealer_id) {
				return _filter(this.specificDealers, {
					dealer_id: this.item.dealer_id,
				});
			}

			if (this.editedItem.dealer_id) {
				return _filter(this.specificDealers, {
					dealer_id: this.editedItem.dealer_id,
				});
			}

			return this.specificDealers;
		},
		internetShops() {
			return this.$store.state.groupShops.internetShops;
		},
		phoneShops() {
			return this.$store.state.groupShops.phoneShops;
		},
		formTitle() {
			return _isEmpty(this.item) ? 'New Group Shop' : 'Edit Group Shop';
		},
		secretShopper() {
			return _some(this.$auth.user().roles, { name: 'secret-shopper' });
		},
		accountManager() {
			return _some(this.$auth.user().roles, { name: 'account-manager' });
		},
		isAutomotive() {
			return this.$auth.user().dealer.is_active;
		},
		administrator() {
			return _some(this.$auth.user().roles, {
				name: 'super-administrator',
			});
		},
		filtered() {
			return this.internetShops.filter((shop) =>
				shop.title.includes(this.search.internetShops)
			);
		},
		paginated() {
			return this.filtered.slice(0, this.limit.internetShop);
		},
		hasNextPage() {
			return this.paginated.length < this.filtered.length;
		},
	},
	created() {
		this.$validator.localize('en', {
			attributes: {
				group_shop_name: 'group shop name',
				internet_shop: 'internet shop',
				company: 'company',
			},
		});
		if (this.accountManager) {
			this.selectedDealer(this.$auth.user().dealer_id);
		}
		this.fetchShopStatuses();
		this.fetchMysteryShopRequests();
	},
	methods: {
		selectedDealer(value) {
			this.editedItem.specific_dealer_id = '';
			if (value) {
				this.isDealerEmpty = false;
				this.getSpecificDealers(value);
				return;
			}
			return (this.isDealerEmpty = true);
		},
		getSpecificDealers(id) {
			this.loading.specificDealer = true;
			this.axios.get(`/dealer/${id}/secret-shop-dealers`).then(({ data }) => {
				_forEach(data, (specificDealer) => {
					if (_findIndex(this.specificDealers, { id: specificDealer.id }) === -1) {
						this.specificDealers.push(specificDealer);
					}
				});

				this.$nextTick(() => {
					this.loading.specificDealer = false;
					if (this.item.dealer_id === 48 && !_isEmpty(this.item.mystery_shop_request)) {
						this.editedItem.specific_dealer_id = parseInt(
							this.item.mystery_shop_request.dealership_id
						);
					}
				});
			});
		},
		filteredLocalCompetitors(id) {
			this.editedItem.competitor_id = [];
			this.localCompetitors = [];
			let params = {
				state_id: [],
				city_id: [],
				internetShop_id: [],
			};
			this.editedItem.internet_shops.forEach((element) => {
				params.state_id.push(element.state.id);
				params.city_id.push(element.city.id);
				params.internetShop_id.push(element.id);
			});

			if (params.state_id.length !== 0 && params.length !== 0) {
				this.isCompetitorEmpty = false;
				return this.getInternetShop(params, id);
			}

			return (this.isCompetitorEmpty = true);
		},
		getInternetShop(id, competitorsId) {
			this.loading.localCompetitor = true;
			this.axios.post('internetshop', id).then(({ data }) => {
				lodashEach(data, (localCompetitor) => {
					const createdAt = !_isEmpty(localCompetitor.created_at)
						? dayjs(localCompetitor.created_at).format('MMM D, YYYY')
						: '';

					this.localCompetitors.push({
						id: localCompetitor.id,
						name: localCompetitor.specific_dealer.name,
						dealerId: localCompetitor.id,
						createdAt: createdAt,
					});
				});

				if (competitorsId != null) {
					this.editedItem.competitor_id = competitorsId;
				}
				this.loading.localCompetitor = false;
			});
		},
		save() {
			this.$validator.validate('*').then((result) => {
				if (_isEmpty(this.item) && result) {
					return this.processSave();
				}
				return this.processUpdate();
			});
		},
		extractIds(shops) {
			const id = [];
			shops.forEach((shop) => {
				return typeof shop !== 'object' ? id.push(shop) : id.push(shop.id);
			});

			return id;
		},
		processUpdate() {
			this.loading.request = true;
			let data = _cloneDeep(this.editedItem);

			data.id = this.item.id;
			data.phone_shops = this.extractIds(data.phone_shops);
			data.internet_shops = this.extractIds(data.internet_shops);
			data.dealer_id = _isNumber(this.editedItem.dealer_id)
				? this.editedItem.dealer_id
				: this.editedItem.dealer_id.id;
			data.specific_dealer_id = this.editedItem.specific_dealer_id;
			data.hide_dealer_name = this.editedItem.hide_dealer_name;
			data.hide_detailed_report_btn = this.editedItem.hide_detailed_report_btn;
			data.request_id = this.requestId;
			data.status = this.shopStatus;
			data.additional_notes = this.shopAdditionalNotes;

			this.axios
				.patch(`secret-shop-management/group-shops/${this.item.id}`, data)
				.then(({ data }) => {
					this.$notify('success', 'Group shop successfully updated!');
					this.getGroupShops();
					this.close();
				})
				.catch((errors) => {
					this.loading.request = false;
					this.interactWithErrorBag(errors, this.errors);
				})
				.finally(() => {
					this.loading.request = false;
				});
		},
		processSave() {
			this.loading.request = true;
			let data = _cloneDeep(this.editedItem);
			data.request_id = this.requestId;
			data.status = this.shopStatus;
			data.additional_notes = this.shopAdditionalNotes;

			data.phone_shops = this.extractIds(data.phone_shops);
			data.internet_shops = this.extractIds(data.internet_shops);

			this.axios
				.post('secret-shop-management/group-shops', data)
				.then(({ data }) => {
					this.$notify('success', 'Group shop successfully created!');
					this.getGroupShops();
					this.close();
				})
				.catch((errors) => {
					this.loading.request = false;
					this.interactWithErrorBag(errors, this.errors);
				})
				.finally(() => {
					this.loading.request = false;
				});
		},
		close() {
			this.dialog = false;
			this.editedItem.name = '';
			this.editedItem.dealer_id = '';
			this.editedItem.specific_dealer_id = '';
			this.editedItem.internet_shops = [];
			this.editedItem.phone_shops = [];
			this.editedItem.hide_dealer_name = false;
			this.editedItem.hide_detailed_report_btn = false;
		},
		setEditForm() {
			this.getSpecificDealers(this.item.dealer_id);

			this.fetchMysteryShopRequests();
			this.editedItem.name = this.item.name;
			this.editedItem.dealer_id = this.item.dealer;
			this.editedItem.internet_shops = this.item.internet_shops;
			this.editedItem.phone_shops = this.item.phone_shops;
			this.editedItem.hide_dealer_name = this.item.hide_dealer_name;
			this.editedItem.hide_detailed_report_btn = this.item.hide_detailed_report_btn;
			this.editedItem.specific_dealer_id = this.item.specific_dealer;
			this.filteredLocalCompetitors(this.item.competitor_id);

			if (this.item.dealer_id) {
				this.isDealerEmpty = false;
			}
		},
		setShopDropdownValue(type, value) {
			this.editedItem[type] = value;
			if (type == 'internet_shops') {
				this.filteredLocalCompetitors();
			}
		},
		fetchShopStatuses() {
			this.axios.get('secret-shop-statuses').then(({ data }) => {
				this.shopStatuses = data.statuses;
			});
		},
		setRequestValue() {
			const items = this.mysteryShopRequest.items;
			if (!_isEmpty(this.item.mystery_shop_request)) {
				const index = _findIndex(items, {
					request_id: this.item.mystery_shop_request.request_id,
				});

				const item = items[index];

				this.mysteryShopRequest.selectedItem = item;
				this.requestId = item.request_id;
				this.shopStatus = item.status;
				this.shopAdditionalNotes = item.notes;
			}
		},
		searchMysteryShopRequests: _debounce(function (search) {
			this.fetchMysteryShopRequests(search);
		}, 1000),
		fetchMysteryShopRequests(search) {
			let keyword = null;
			this.shopRequestLoading = true;

			if (!_isEmpty(search)) {
				keyword = search;
			}

			if (!_isEmpty(this.item.mystery_shop_request)) {
				keyword = this.item.mystery_shop_request.request_id;
			}

			let data = [];

			if (!_isEmpty(this.item.mystery_shop_request)) {
				data = {
					items_per_page: 5,
					page: this.mysteryShopRequest.pagination.currentPage,
					status: ['new-request'],
					shop_id: this.item.id,
				};
			} else {
				data = {
					items_per_page: 5,
					page: this.mysteryShopRequest.pagination.currentPage,
					keyword,
					status: ['new-request'],
				};
			}

			this.shopRequestsLoading = true;

			this.axios
				.get('salesforce-requests', {
					params: data,
				})
				.then(({ data }) => {
					this.mysteryShopRequest.items = data.items;
					this.mysteryShopRequest.pagination.total = data.meta.total_items;

					_forEach(data.items, (item) => {
						this.mysteryShopRequest.items.push(item);
					});

					this.setRequestValue();
					this.$nextTick(() => {
						this.shopRequestsLoading = false;
					});
				})
				.catch(() => {
					this.shopRequestsLoading = false;
				});
		},
	},
};
</script>

<style scoped></style>
